<template>
  <div class="order-list">
    <div class="filter-content">
      <div class="time-content">
        <el-col class="line" :span="4">录入时间</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="开始日期" value-format="timestamp" :picker-options="pickerOptionOrdStart"
                          v-model="order_start" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptionOrdEnd"
                          v-model="order_end" style="width: 100%;"></el-date-picker>
        </el-col>
      </div>
      <el-button type="primary" class="search-btn" @click="searchHandle">搜索</el-button>
      <el-button type="success" class="search-btn export-btn" @click="exportClick" :disabled="export_dis">导出数据</el-button>
    </div>
    <el-table
      :data="listData"
      v-loading="loading"
      border
      header-row-class-name="change-header-style"
      style="width: 100%;margin-top: 20px;min-height: 500px;">
      <el-table-column
        type="index"
        :index="indexHandle"
        label="序号"
        width="40"
        fixed="left">
      </el-table-column>
      <el-table-column
        prop="projName"
        width="280"
        label="项目名称"
        fixed="left">
        <template slot="header" slot-scope="scope">
          <span>项目名称</span>
          <el-input @keyup.enter.native="searchHandle" v-model="proj_name_search" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="csrName"
        label="客户姓名"
        width="140"
        fixed="left">
        <template slot="header" slot-scope="scope">
          <span>客户姓名</span>
          <el-input @keyup.enter.native="searchHandle" v-model="user_name_search" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="csrGender"
        width="50"
        label="性别">
      </el-table-column>
      <el-table-column
        prop="csrAge"
        label="年龄"
        width="50">
      </el-table-column>
      <el-table-column
        prop="csrMobile"
        label="手机号码"
        width="120">
      </el-table-column>
      <el-table-column
        prop="checkCode"
        label="识别码"
        width="190">
      </el-table-column>
      <el-table-column
        prop="matchingState"
        label="匹配状态"
        width="100">
        <template slot="header" slot-scope="scope">
          <span style="text-align: center;">匹配状态</span>
          <el-select v-model="matching_state_select" placeholder="请选择" popper-class="filter_options download_options"
                     @change="searchHandle">
            <el-option
              v-for="item in matching_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.matchingState == 1"
               style="padding:4px 8px;background:#5cb85c;color:#fff;text-align: center;border-radius: 4px;">已匹配
          </div>
          <div v-if="scope.row.matchingState == 0"
               style="padding:4px 8px;background:#d9534f;color:#fff;text-align: center;border-radius: 4px;">未匹配
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="examineState"
        label="审核状态"
        width="120">
        <template slot="header" slot-scope="scope">
          <span style="text-align: center;">审核状态</span>
          <el-select v-model="examine_state_select" placeholder="请选择" popper-class="filter_options order_state_options"
                     @change="searchHandle">
            <el-option
              v-for="item in examine_state_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.examineState == 0"
               style="padding:4px 8px;background:#f0ad4e;color:#fff;text-align: center;border-radius: 4px;">待审核
          </div>
          <div v-if="scope.row.examineState == 10"
               style="padding:4px 8px;background:#5cb85c;color:#fff;text-align: center;border-radius: 4px;">审核通过
          </div>
          <div v-if="scope.row.examineState == 100"
               style="padding:4px 8px;background:#999999;color:#fff;text-align: center;border-radius: 4px;">废单
          </div>
          <div v-if="scope.row.examineState == 20"
               style="padding:4px 8px;background:#d9534f;color:#fff;text-align: center;border-radius: 4px;">驳回
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="160"
        prop="heartRecvTime"
        label="录入时间">
        <template slot-scope="scope">
          <div v-if="scope.row.heartRecvTime != 0 && scope.row.heartRecvTime != null">
            {{ scope.row.heartRecvTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="examCode"
        label="客户编码"
        width="210">
        <template slot="header" slot-scope="scope">
          <span>客户编码</span>
          <el-input @keyup.enter.native="searchHandle" v-model="exam_code_search" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        width="170"
        label="操作"
        fixed="right">
        <template slot-scope="scope">
          <el-button type="warning" title="操作记录" icon="el-icon-s-order" @click="showOperationDia(scope.row)"></el-button>
          <el-button v-if="scope.row.matchingState == 0 && scope.row.examine_state != 100" @click="showEditDiaHandle(scope.row)" type="primary" title="修改"
                     style="cursor: pointer;display: inline-block;" icon="el-icon-edit" size="mini"></el-button>
          <el-button v-if="scope.row.matchingState == 0" @click="delHandle(scope.row)" type="danger"
                     style="cursor: pointer;display: inline-block;" icon="el-icon-delete" title="删除"
                     size="mini"></el-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="no-data">
          当前暂无数据
        </div>
      </template>
    </el-table>

    <page-nation :total="page_total" @pageChange="pageChange" :current_page="current_page" :page_sizes="page_sizes"
                 :page_limit="page_limit"></page-nation>

    <el-dialog
      title="编辑"
      :visible.sync="isShowEditDia"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="form-dialog"
      show-close>
      <div>
        <p class="mess">项目名称： {{orderForm.projName}}</p>
        <el-form ref="orderForm" :rules="orderFromRules" :model="orderForm" label-width="100px">
          <el-form-item label="客户姓名" prop="csrName">
            <el-input v-model="orderForm.csrName"></el-input>
          </el-form-item>
          <el-form-item label="客户性别" prop="csrGender">
            <el-radio-group v-model="orderForm.csrGender">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="客户年龄" prop="csrAge">
            <el-input-number v-model="orderForm.csrAge" :min="1" :max="150"></el-input-number>
          </el-form-item>
          <el-form-item label="手机号码" prop="csrMobile">
            <el-input v-model="orderForm.csrMobile"></el-input>
          </el-form-item>
          <el-form-item label="客户经理代码">
            <el-input v-model="orderForm.checkCode"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowEditDia = false">取 消</el-button>
        <el-button type="primary" @click="updateOrderHandle('orderForm')">确 定</el-button>
      </div>
    </el-dialog>

    <operation-record ref="operation_record"></operation-record>

  </div>
</template>

<script>
import PageNation from "./Common/PageNation";
import OperationRecord from "./Common/OperationRecord";
import ApiService from "../service/ApiService";
import pub from "../service/public";
export default {
  name: "OrderList",
  components:{
    PageNation:PageNation,
    OperationRecord:OperationRecord,
  },
  data(){
    return {
      listData: [],
      loading: false,
      order_start: '',  // 发单时间
      order_end: '',
      pickerOptionOrdStart: {
        disabledDate: time => {
          if (this.order_end) {
            return time.getTime() > new Date(this.order_end).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionOrdEnd: {
        disabledDate: time => {
          if (this.order_start) {
            return time.getTime() < new Date(this.order_start).getTime() || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      proj_name_search: '',
      user_name_search: '',
      exam_code_search: '',
      matching_state_select: -1,
      matching_options: [
        {value: -1, label: '全部'},
        {value: 0, label: '未匹配'},
        {value: 1, label: '已匹配'}
      ],
      page_total: 0,
      current_page: 1,
      page_sizes: [10, 20, 50, 100],
      page_limit: 10, // 每页多少条
      isShowEditDia: false,
      orderForm: {},
      orderFromRules: {
        csrName: [
          {required: true, message: '请输入客户姓名', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
        ],
        csrGender: [
          {required: true, message: '请选择客户性别', trigger: 'change'}
        ],
        csrAge: [
          {required: true, message: '请输入客户年龄', trigger: 'blur'}
        ],
        csrMobile: [
          {required: true, message: '请输入手机号码', trigger: 'blur'}
        ],
      },
      examine_state_options: [
        {value: -1, label: '全部'},
      ],
      examine_state_select: -1,
      export_dis: true,
    }
  },
  created() {
    this.initData();
    this.getExamineStateList();
  },
  methods:{
    indexHandle(index){
      index = (index + 1) + (this.current_page - 1) * this.page_limit;
      return index
    },
    // 翻页、切换每页条数
    pageChange(item) {
      this.current_page = item.current_page;
      if(item.type == 'size'){
        this.page_limit = item.page_limit;
      }
      this.initData(); //改变页码，重新渲染页面
    },
    initData() {
      let that = this;
      that.loading = true;
      let order_start = 0;
      let order_end = 0;
      if (that.order_start) {
        order_start = that.order_start / 1000;
      }
      if (that.order_end) {
        order_end = that.order_end / 1000;
      }

      let params = {
        page: {
          number: that.current_page - 1,
          limit: that.page_limit
        },
        keyWord: [],
        parms: {
          projName: that.proj_name_search,//项目名称
          csrName: that.user_name_search,//姓名
          matchingState: that.matching_state_select,//是否匹配
          recvStart:order_start,
          recvEnd:order_end,
          examineState:that.examine_state_select,
          examCode:that.exam_code_search
        }
      }

      that.listData = [];
      ApiService.getHeartOrderList(params).then(res => {
        this.loading = false;
        if (res.code == 0) {
          if(res.data.pageList){
            that.listData = res.data.pageList;
            that.page_total = res.data.itemTotal;
            if(that.page_total > 0){
              that.export_dis = false;
            }else{
              that.export_dis = true;
            }
          }
        } else if (res.code == 204) {
          pub.refresh(that.initData);
        } else {
          pub.analysisReturnCode(res);
        }
      }).catch(error => {
        that.loading = false;
        if (error == "Error: Request failed with status code 400") {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 2000
          });
        }
        console.log("发单列表报错信息：", error)
      });
    },
    // 显示编辑弹窗
    showEditDiaHandle(val){
      this.orderForm = {
        heartRecvId:val.heartRecvId,
        projName:val.projName,
        csrName:val.csrName,
        csrAge:val.csrAge,
        csrGender:val.csrGender,
        checkCode:val.checkCode,
        csrMobile:val.csrMobile
      };
      this.isShowEditDia = true;
    },
    // 编辑之后确定按钮
    updateOrderHandle(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitUpdateOrderHandle();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 提交更新的内容
    submitUpdateOrderHandle(){
      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms:{
          heartRecvId:this.orderForm.heartRecvId,//订单接收信息ID
          csrName:this.orderForm.csrName,//姓名
          csrGender:this.orderForm.csrGender,//性别
          csrAge:this.orderForm.csrAge,//年龄
          csrMobile:this.orderForm.csrMobile,// 手机号码
          checkCode:this.orderForm.checkCode,// 项目经理代码
        }

      }
      ApiService.updateHeartOrder(params).then(res => {
        this.isShowEditDia = false;
        if (res.code == 0) {
          this.initData();
        } else if (res.code == 204) {
          pub.refresh(this.submitUpdateOrderHandle);
        } else {
          pub.analysisReturnCode(res);
        }
      });
    },
    //删除
    delHandle(val) {
      this.$confirm('确定删除订单【' + ' ' + val.csrName + ' (' + val.csrMobile + ')】的信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(() => {
        this.delOrderList(val.heartRecvId);
      }).catch(() => {
        console.log('已取消删除');
      });
    },
    //执行删除
    delOrderList(id){
      let heartRecvId = new Array();
      let currentId = {
        heartRecvId:id
      };
      heartRecvId.push(currentId);
      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms:heartRecvId
      };
      console.log(params)
      ApiService.delHeartOrder(params).then(res => {
        if (res.code == 0) {
          this.current_page = 1;
          this.initData();
        } else if (res.code == 204) {
          pub.refresh(this.delOrderList(id));
        } else {
          pub.analysisReturnCode(res);
        }
      }).catch(error => {
        if (error == "Error: Request failed with status code 400") {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    // 搜索
    searchHandle(){
      this.current_page = 1;
      this.initData();
    },
    //操作列表
    showOperationDia(item){
      this.$refs.operation_record.showOperationListDia(item);
    },
    // 审核状态
    getExamineStateList(){
      ApiService.GetExamineStateList({}).then(res => {
					if (res.code == 0) {
						this.examine_state_options = this.examine_state_options.concat(res.data.pageList);
					} else if (res.code == 400 || res.code == 403) {
						this.$router.push("/login");
					} else {
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'warning',
							duration: 1000
						});
					}
				}).catch(error => {
					if (error == "Error: Request failed with status code 400") {
						this.$message({
							showClose: true,
							message: error,
							type: 'error',
							duration: 2000
						});
					}
					console.log("审核状态报错信息：", error);
				});
    },
    exportClick() {
      let order_start = 0;
      let order_end = 0;
      if (this.order_start) {
        order_start = this.order_start / 1000;
      }
      if (this.order_end) {
        order_end = this.order_end / 1000;
      }

      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          projName: this.proj_name_search,//发送机构名称
          csrName: this.user_name_search,//姓名
          examineState: this.examine_state_select,
          examCode: this.exam_code_search,
          matchingState: this.matching_state_select,//是否匹配
          recvStart: order_start,
          recvEnd: order_end
        }
      }
      let that = this;
      ApiService.ExportHeartOrderData(params).then(res => {
        if (res.data.pageList[0]) {
          let url = '/' + res.data.pageList[0];
          pub.fileLinkToStreamDownload(pub.API_ROOT + url, '客户信息列表', 'zip')
        }
        // that.download(localStorage.getItem('API_ROOT_ulwf_mgr') + url);
      }).catch(error => {
        this.loading = false;
        if (error == "Error: Request failed with status code 400") {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 2000
          });
        }
        console.log("保险导出报错信息：", error);
      });
    },
    download(url) {
      if (!url) {
        return
      }
      let link = document.createElement('a');
      link.style.display = 'none'
      link.href = url;
      link.setAttribute('download', '客户信息列表.zip');
      document.body.appendChild(link);
      link.click();
    },
  }
}
</script>

<style scoped lang="scss">
 >>>.form-dialog .mess{
  line-height: 20px;
  text-align: left;
  padding-left: 30px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue